<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="exportModal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">Domain-Ip List</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <template v-if="!loading">
              <div class="row">
                <div class="col-md-12 text-center">
                  <p class="d-inline">
                    Domain Ip list is ready. Click Export to download file.
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center">
                  <json-excel
                    class="btn btn-primary"
                    :data="data"
                    :fields="columns"
                    name="USER-IP.xls"
                  >
                    Export
                  </json-excel>
                </div>
              </div>
            </template>
            <div v-else class="loader"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init"
import JsonExcel from "vue-json-excel";
export default {
  name: "DomainIpList",
  components: {JsonExcel},
  data () {
    return {
      loading: false,
      data: [],
      columns: {
        "Domain": "domain",
        "IP": "ip",
        "Primary Domain": "primaryDomain",
      },
    }
  },
  methods: {
    async load() {
      $('#exportModal').modal('show');
      this.loading = true
      await this.getData();
      this.loading = false
    },
    async getData () {
      const allHostingAccountsRef = await db.collection('hostingAccounts').get();
      const allDomainIp = [];
      allHostingAccountsRef.forEach(data => {
        console.log(data.id)
        for (const account of data.data().accounts) {
          if (account.primary.domain) {
            allDomainIp.push({ domain: account.primary.domain, ip: account.primary.serverIP, primaryDomain: account.primary.domain })
          }
          for (const addon of account.addon) {
            if (addon.domain) {
              allDomainIp.push({domain: addon.domain, ip: account.primary.serverIP, primaryDomain: account.primary.domain })
            }
          }
        }
      });
      this.data = allDomainIp
    }
  }
}
</script>

<style scoped>

</style>
